import React, { Component } from "react"
import { ModalContainer, ModalDialog } from "react-modal-dialog"
import ItensDeContratoForm from "./ItensDeContratoForm"
import * as ApiHelper from "../../ApiHelper"
import { HttpError } from "../../components"
export default class ItensModal extends Component {
  constructor() {
    super()
    this.callBackItens = this.callBackItens.bind(this)
    this.state = { isShowingModal: false }
  }
  getUnidades() {
    ApiHelper.getItemDeContrato(this.props.editingItem.id, (item, error) => {
      if (item) {
        this.props.callBack(item)
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  callBackItens() {
    this.getUnidades()
  }
  render() {
    if (this.state.httpError) {
      return (
        <div onClick={this.props.onClose}>
          {this.props.show && (
            <ModalContainer onClose={this.props.onClose}>
              <ModalDialog
                style={{ width: "70%" }}
                onClose={this.props.onClose}
              >
                <HttpError
                  message={this.state.httpError.message}
                  status={this.state.httpError.status}
                />
              </ModalDialog>
            </ModalContainer>
          )}
        </div>
      )
    }
    return (
      <div onClick={this.props.onClose}>
        {this.props.show && (
          <ModalContainer onClose={this.props.onClose}>
            <ModalDialog style={{ width: "70%" }} onClose={this.props.onClose}>
              <ItensDeContratoForm
                editingItem={this.props.editingItem}
                callBackItens={this.callBackItens}
              />
            </ModalDialog>
          </ModalContainer>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/modais/ItensModal.js